/**
 * マッチング率
 */
export const MatchingRate = {
  A_PLUS: 'A+',
  A: 'A',
  A_MINUS: 'A-',
  B_PLUS: 'B+',
  B: 'B',
  C: 'C',
  D: 'D',
  NOT_EVALUATABLE: '-',
} as const

export const MatchingRateLabel: { [key: string]: string } = {
  [MatchingRate.A_PLUS]: 'A+',
  [MatchingRate.A]: 'A',
  [MatchingRate.A_MINUS]: 'A-',
  [MatchingRate.B_PLUS]: 'B+',
  [MatchingRate.B]: 'B',
  [MatchingRate.C]: 'C',
  [MatchingRate.D]: 'D',
  [MatchingRate.NOT_EVALUATABLE]: '-',
}

export type MatchingRateValue = (typeof MatchingRate)[keyof typeof MatchingRate]

export const convertMatchingRate = (
  matchingRate: number
): MatchingRateValue => {
  if (matchingRate >= 90) {
    return MatchingRate.A_PLUS
  } else if (matchingRate >= 80) {
    return MatchingRate.A
  } else if (matchingRate >= 70) {
    return MatchingRate.A_MINUS
  } else if (matchingRate >= 60) {
    return MatchingRate.B_PLUS
  } else if (matchingRate >= 50) {
    return MatchingRate.B
  } else if (matchingRate >= 40) {
    return MatchingRate.C
  } else if (matchingRate === 0) {
    return MatchingRate.NOT_EVALUATABLE
  } else {
    return MatchingRate.D
  }
}
